/**
 * @deprecated
 */
import $ from 'jquery';

document.addEventListener('DOMContentLoaded', function() {
    fireEvent(4000); // Zpoždění 4000 milisekund (4 sekundy)
});

function fireEvent(time) {
    setTimeout(function() {
        console.log('Skript se spustil po zpoždění.');
        const flatFloorAreasInput = document.getElementById('flat_floorAreas');
        const flatAddressFull = document.getElementById('flat_address_full');
        if (!flatFloorAreasInput) {
            return;
        }
        if (!flatAddressFull) {
            return;
        }
        flatFloorAreasInput.removeEventListener('blur', handleBlur);
        function handleBlur() {
            console.log('Blur na flat_floorAreas');
            const event = new Event('requestValidation', { bubbles: true });
            flatAddressFull.dispatchEvent(event);
            fireEvent(1000); // zavolá sama sebe zpoždění 1000 milisekund (1 sekunda)
        }
        flatFloorAreasInput.addEventListener('blur', handleBlur);
    }, time);
}

/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
if (window.q) {
	window.q.forEach((f) => {
		$(f);
	});
}



// WEBPACK FOOTER //
// ./fe/web-majetek/src/js/web.js